import React, { useEffect, useState } from 'react';

const LOADER_MSGS = [
  "Prepping your kit…",
  "Mixing the colors…",
  "Loading the canvas…",
  "Almost ready to paint…",
];

const DABS = [
  { cx: 72,  cy: 80,  r: 9,  fill: "#FF6A3D" },
  { cx: 99,  cy: 70,  r: 10, fill: "#FFC24B" },
  { cx: 126, cy: 78,  r: 9,  fill: "#3FB984" },
  { cx: 134, cy: 104, r: 8,  fill: "#4F8DF0" },
  { cx: 70,  cy: 106, r: 8,  fill: "#C66BE0" },
];

const KitLoader = ({ label }: { label?: string }) => {
  const [msg, setMsg] = useState(label || LOADER_MSGS[0]);

  useEffect(() => {
    if (label) return;
    let i = 0;
    const id = setInterval(() => {
      i = (i + 1) % LOADER_MSGS.length;
      setMsg(LOADER_MSGS[i]);
    }, 600);
    return () => clearInterval(id);
  }, [label]);

  return (
    <div
      className="kitloader"
      style={{
        position: 'absolute', inset: 0, zIndex: 30,
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 26,
        background: 'rgba(251,244,246,.82)', backdropFilter: 'blur(6px)',
      }}
    >
      <div style={{ width: 210, height: 168, position: 'relative' }}>
        <svg viewBox="0 0 200 160" width="210" height="168" style={{ overflow: 'visible' }}>
          <ellipse cx="100" cy="140" rx="62" ry="9" fill="rgba(43,43,46,.08)" className="kl-shadow" />
          <g className="kl-palette">
            <path
              d="M100 44 C148 44 168 74 168 98 C168 118 150 128 134 128 C122 128 120 118 110 118 C100 118 96 130 84 132 C58 136 32 120 32 92 C32 64 58 44 100 44 Z"
              fill="#fff" stroke="var(--rule)" strokeWidth="2.5"
            />
            <ellipse cx="92" cy="108" rx="11" ry="8" fill="var(--paper-warm)" stroke="var(--rule)" strokeWidth="1.5" />
          </g>
          {DABS.map((d, i) => (
            <circle
              key={i} cx={d.cx} cy={d.cy} r={d.r} fill={d.fill}
              className="kl-dab"
              style={{ animationDelay: `${0.18 + i * 0.16}s`, transformOrigin: `${d.cx}px ${d.cy}px` }}
            />
          ))}
          <g className="kl-brush" style={{ transformOrigin: '168px 30px' }}>
            <rect x="150" y="18" width="62" height="9" rx="4.5" transform="rotate(34 181 22)" fill="var(--terra)" />
            <rect x="142" y="36" width="20" height="11" rx="3" transform="rotate(34 152 41)" fill="#C9C4BA" />
            <path d="M132 50 l16 11 -7 11 -16 -11 z" fill="#FF6A3D" className="kl-tip" />
            <circle cx="129" cy="68" r="2.4" fill="#FF6A3D" className="kl-drip" />
          </g>
        </svg>
      </div>

      <div style={{ textAlign: 'center' }}>
        <div
          className="kl-msg"
          style={{
            fontFamily: 'var(--display)', fontSize: 17, fontWeight: 600,
            color: 'var(--ink)', letterSpacing: -0.1,
          }}
        >
          {msg}
        </div>
        <div className="kl-dots" style={{ display: 'flex', gap: 6, justifyContent: 'center', marginTop: 12 }}>
          {[0, 1, 2].map(i => (
            <span key={i} className="kl-dot" style={{ animationDelay: `${i * 0.16}s` }} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default KitLoader;
